module.exports = __webpack_public_path__ + "img/Jd.eaacc6c7.png";